
import React, { Component } from "react";
import axios from "axios";
import Serverurl from "./Apiurl";
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

class InvoiceSetting extends Component {

   constructor(props) {
    super(props);

    this.state = {
        redirect: false,

        InvoicePrefix: "",
        SerialNo: "",
        GSTDisplay: "YES",
        HSNDisplay: "YES",
        TopMessage: "",
        BottomMessage: "",
        SignatureDisplay: "YES",

        btndisabled: false,
        submitbtn: "Save",

        erropen: false,
        errormessage: "",
        alertype: "error"
    };
}

 myChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    this.setState({
        [nam]: val
    });
}

 componentDidMount() {
	  
	  if(localStorage.getItem("GBuserid")==null)
		 {

		   this.setState({
            logredirect: true,
			pagename:'/Businesslogin'
          })
		  }
		  this.apicall();
  }

 apicall = () => {

    const bu_id = localStorage.getItem("GBuserid");

    if (!bu_id) return;

    axios.post(
        Serverurl + "ajaxadminoption.php?action=getdata&ao_bu_id=" + bu_id + "&ao_name=invoice"
    )
    .then(res => {

        console.log("API DATA:", res.data);

        if (res.data && res.data.length > 0) {

            let data = res.data[0];

            let arr = data.ao_value.split("~");

            console.log("ARRAY:", arr);

            this.setState({
                InvoicePrefix: arr[0] || "",
                SerialNo: arr[1] || "",
                GSTDisplay: arr[2] || "YES",
                HSNDisplay: arr[3] || "YES",
                TopMessage: arr[4] || "",
                BottomMessage: arr[5] || "",
                SignatureDisplay: arr[6] || "YES"
            }, () => {
                console.log("STATE:", this.state);
            });

        }

    })
    .catch(error => {
        console.log(error);
    });
}

 handleSave = (event) => {

    event.preventDefault();

    if (this.state.InvoicePrefix === "") {
        this.setState({
            errormessage: "Please Enter Invoice Prefix.",
            erropen: true
        });
        return false;
    }

    if (this.state.SerialNo === "") {
        this.setState({
            errormessage: "Please Enter Serial Number.",
            erropen: true
        });
        return false;
    }

    this.setState({
        btndisabled: true,
        submitbtn: "Processing..."
    });

    var ao_value =
        this.state.InvoicePrefix + "~" +
        this.state.SerialNo + "~" +
        this.state.GSTDisplay + "~" +
        this.state.HSNDisplay + "~" +
        this.state.TopMessage + "~" +
        this.state.BottomMessage + "~" +
        this.state.SignatureDisplay;

    var formData = new FormData();

    formData.append("action", "insertupdate");
	formData.append("ao_name","invoice");
    formData.append("ao_bu_id", localStorage.getItem("GBuserid"));
    formData.append("ao_value", ao_value);

    axios.post(Serverurl + "ajaxadminoption.php", formData)
        .then(res => {

            this.setState({
                btndisabled: false,
                submitbtn: "Save",
                alertype: "success",
                erropen: true,
                errormessage: "Invoice Settings Saved Successfully."
            });

        });

}

  handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 

  goBack = () => {
  window.history.back();
};

    render() {

        return (
		
            <div className="formdisplay">

<div className="boxheading">
  <div className="heading-with-back">
              <ChevronLeftIcon
  className="global-back-arrow"
  onClick={() => window.history.back()}
/>
    <h2>Invoice Setting</h2>
  </div>
</div>

<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.alertype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>              



<p><TextField
    fullWidth
    size="small"
	label="Invoice Prefix"
    name="InvoicePrefix"
    placeholder="Invoice Prefix"
    value={this.state.InvoicePrefix}
    onChange={this.myChangeHandler}
	InputLabelProps={{ shrink: true }}
	sx={{
      "& .MuiOutlinedInput-root": {
        borderRadius: "10px",
		padding: "4px 0px"
      },
    }}
/></p>

     <p>          <TextField
    fullWidth
    size="small"
	label="Serial Number"
    name="SerialNo"
    placeholder="Serial Number"
    value={this.state.SerialNo}
    onChange={this.myChangeHandler}
	InputLabelProps={{ shrink: true }}
	sx={{
      "& .MuiOutlinedInput-root": {
        borderRadius: "10px",
		padding: "4px 0px"
      },
    }}
/></p>

            <p>
  <TextField
    fullWidth
    select
	  label="GST Display"
    name="GSTDisplay"
    placeholder="GST Display"
    value={this.state.GSTDisplay}
    onChange={this.myChangeHandler}
	InputLabelProps={{ shrink: true }}
	sx={{
      "& .MuiOutlinedInput-root": {
        borderRadius: "10px",
		padding: "4px 0px"
      },
    }}
  >
    <MenuItem value="YES">Yes</MenuItem>
    <MenuItem value="NO">No</MenuItem>
    
  </TextField>
</p>

<p>
  <TextField
    fullWidth
	label="HSN Display"
    select
    name="HSNDisplay"
    placeholder="HSN Display"
    value={this.state.HSNDisplay}
    onChange={this.myChangeHandler}
	InputLabelProps={{ shrink: true }}
	sx={{
      "& .MuiOutlinedInput-root": {
        borderRadius: "10px",
		padding: "4px 0px"
      },
    }}
  >
    <MenuItem value="YES">Yes</MenuItem>
    <MenuItem value="NO">No</MenuItem>
  </TextField>
</p>

              <p> 
  <TextField
    fullWidth
    multiline
    rows={3}
	label="Invoice Top Message"
    name="TopMessage"
    placeholder="Invoice Top Message"
    value={this.state.TopMessage}
    onChange={this.myChangeHandler}
	InputLabelProps={{ shrink: true }}
/></p>

               <p> <TextField
    fullWidth
    multiline
    rows={3}
	label="Invoice Bottom Message"
    name="BottomMessage"
    placeholder="Invoice Bottom Message"
    value={this.state.BottomMessage}
    onChange={this.myChangeHandler}
	InputLabelProps={{ shrink: true }}
	sx={{
      "& .MuiOutlinedInput-root": {
        borderRadius: "10px",
		padding: "4px 0px"
      },
    }}
/></p>

<p>
  <TextField
    fullWidth
    select
	label="Display Signature"
    name="SignatureDisplay"
    placeholder="Display Signature"
    value={this.state.SignatureDisplay}
    onChange={this.myChangeHandler}
	InputLabelProps={{ shrink: true }}
	sx={{
      "& .MuiOutlinedInput-root": {
        borderRadius: "10px",
		padding: "4px 0px"
      },
    }}
  >
    <MenuItem value="YES">Yes</MenuItem>
    <MenuItem value="NO">No</MenuItem>
  </TextField>
</p>


<p className="aligncenter"><Button
    type="submit"
    variant="contained"
    className="primartybtn"
    disabled={this.state.btndisabled}
    onClick={this.handleSave}
	        		  sx={{
   
    borderRadius: "20px",
    minWidth: "110px",
  }}
>
    {this.state.submitbtn}
</Button></p>
            </div>
        );
    }
}

export default InvoiceSetting;
